import React from 'react';

const Header = () => (
    <header>
        <div className="wrapper">
            <div id="logo"></div>
            <ul>
                <li><a href="tel:0439432224">0439 432 224</a> | </li>
                <li><a href="mailto:paula@paulabramwell.com.au">paula@paulabramwell.com.au</a></li>
            </ul>
        </div>
    </header>
)

export default Header;